import React, { useEffect, useState } from 'react';
import { Container, Col, Row, Table, Button } from 'react-bootstrap';
import { FileEarmark, GraphUpArrow } from 'react-bootstrap-icons';

import api from '../../services/api';
import './investments.css';
import { getFile } from '../../utils/common.utils';
import FileViewerModal from '../../components/file-viewer-modal';

export type InvestmentDetailsProps = {
  userProfile: {
    userId: number | null;
  };
};

const InvestmentDetails: React.FC<InvestmentDetailsProps> = (props: InvestmentDetailsProps) => {
  const [investments, setInvestments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false);
  const [fileBlob, setFileBlob] = useState();

  useEffect(() => {
    const {
      userProfile: { userId },
    } = props;

    const fetchInvestments = async () => {
      try {
        const responseInvestments = await api.get(`/users/${userId}/investments`);
        setInvestments(responseInvestments.data);
      } catch (error) {
        console.error('Error obteniendo las inversiones:', error);
      }
      setIsLoading(false);
    };

    if (userId) {
      fetchInvestments();
    }
  }, [props]);

  const handleOpenDocument = async (
    fileUrl: string,
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault();
    const file = await getFile(fileUrl);
    if (file) {
      setFileBlob(file);
      setIsDocumentModalOpen(true);
    }
  };

  const renderInvestments = () => {
    if (!investments || investments.length === 0) {
      return (
        <tr>
          <td className="text-center" colSpan={4}>
            No hay inversiones
          </td>
        </tr>
      );
    }
    return investments.map((investment: any) => {
      const fileUrl = `${process.env.REACT_APP_API_BASE_URL}/documents/contracts/${investment.id}/${investment.contracts[0].filename}`;
      return (
        <tr key={investment.id}>
          <td>{investment.folioId}</td>
          <td>{investment.amount}</td>
          <td>{investment.gat}</td>
          <td className="align-center">{investment.startDate}</td>
          <td className="align-center">{investment.endDate}</td>
          <td style={{ whiteSpace: 'nowrap', width: '2%', textAlign: 'center' }}>
            {fileUrl ? (
              <Button variant="link" onClick={(e) => handleOpenDocument(fileUrl, e)}>
                <FileEarmark size={25} color={'green'} />
              </Button>
            ) : (
              <label>-</label>
            )}
          </td>
        </tr>
      );
    });
  };

  return (
    <Container>
      <Row className="mb-4 title">
        <Col md={6} className="d-flex align-items-center">
          <GraphUpArrow size={18} className="me-2" />
          <h4>Mis Inversiones</h4>
        </Col>
      </Row>
      <Row className="mb-3 mt-5">
        <Table responsive striped bordered hover>
          <thead>
            <tr>
              <th>Folio</th>
              <th>Monto de Inversión</th>
              <th>GAT</th>
              <th className="align-center">Fecha de inicio</th>
              <th className="align-center">Fecha de termino</th>
              <th>Contrato</th>
            </tr>
          </thead>
          <tbody>{renderInvestments()}</tbody>
        </Table>
      </Row>
      {isDocumentModalOpen && fileBlob && (
        <FileViewerModal
          isOpen={isDocumentModalOpen}
          file={fileBlob}
          handleCloseModal={() => setIsDocumentModalOpen(false)}
        />
      )}
    </Container>
  );
};

export default InvestmentDetails;
